import { settleApiCall } from '../../../api/utils';
import { getModifierGroupsIds } from '../../../utils/modifierGroups';
import { createFieldToEntityMap } from '../../../utils/common';
export const getPopulatedModifierGroups = async _ref => {
  let {
    modifierGroupsClient,
    populatedModifierGroupsClient,
    items,
    populationLevel,
    cacheModifierGroups
  } = _ref;
  const shouldPopulateModifierGroups = populationLevel == null ? void 0 : populationLevel.modifierGroups;
  if (!shouldPopulateModifierGroups) {
    return {
      data: [],
      hasError: false
    };
  }
  const itemsModifierGroupIds = getModifierGroupsIds(items);
  if (!(itemsModifierGroupIds.length > 0)) {
    return {
      data: [],
      hasError: false
    };
  }
  let modifierGroupsResult = [];
  if (cacheModifierGroups) {
    modifierGroupsResult = cacheModifierGroups;
  } else {
    const modifierGroupsApiResponse = await settleApiCall(() => modifierGroupsClient.getBulk({
      ids: itemsModifierGroupIds
    }));
    if (modifierGroupsApiResponse.hasError) {
      return modifierGroupsApiResponse;
    }
    const populateModifierGroupsResponse = await populatedModifierGroupsClient.createPopulatedModifierGroups(modifierGroupsApiResponse.data.data);
    if (populateModifierGroupsResponse.hasError) {
      return populateModifierGroupsResponse;
    }
    modifierGroupsResult = populateModifierGroupsResponse.data;
  }
  const populatedModifierGroupsMap = createFieldToEntityMap(modifierGroupsResult, 'id');
  return {
    data: modifierGroupsResult,
    idsToEntityMap: populatedModifierGroupsMap,
    hasError: false
  };
};
//# sourceMappingURL=getPopulatedModifierGroups.js.map